import { combineReducers } from "@reduxjs/toolkit";
import LoginReducer from "./LoginReducer";
import AccessReducers from "./AccessReducers";

export const RootReducer = combineReducers({
  login: LoginReducer,
  access: AccessReducers,
});
